module.exports = __webpack_public_path__ + "img/pointA_item5_mob.951b56ac.png";